import React, {FC} from 'react';
import dayjs from "dayjs";
import Button from "react-bootstrap/Button";
import {Link} from "react-router-dom";

const Contact: FC  = () => {

    return <div className={"container-sm"}>
        <div className="d-flex justify-content-center">
            <div className={"row"}>
                <div className={"col p-2"}>
                    <div><h1>Kontakt</h1></div>
                </div>
            </div>
        </div>
    </div>
}
export default Contact;